import type { IPrinter, IPosPrinter } from '@erp/native/interfaces';

export function createWebPrinter(): IPrinter {
  return {
    async list() {
      // Browsers do not expose printer enumeration.
      return [];
    },
    async printPdf(job) {
      // Open the PDF in a new tab and trigger window.print(). The user
      // sees the OS print dialog from there.
      const blob = new Blob([new Uint8Array(job.pdf)], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      const w = window.open(url, '_blank');
      if (!w) {
        return { ok: false, error: 'popup-blocked' };
      }
      // Give the new window a beat to render the PDF before triggering print.
      // Best-effort — some browsers (Safari) won't honour cross-window .print()
      // on a Blob URL, in which case the user clicks the print icon themselves.
      setTimeout(() => {
        try {
          w.focus();
          w.print();
        } catch {
          // Swallow — the PDF tab is open anyway.
        }
      }, 600);
      // Revoke later — the new window holds the URL for now.
      setTimeout(() => URL.revokeObjectURL(url), 60_000);
      return { ok: true };
    },
  };
}

export function createWebPosPrinter(): IPosPrinter {
  // Web cannot drive ESC/POS hardware. We surface a meaningful error so
  // the UI can show a "feature requires desktop app" call to action.
  const NOT_SUPPORTED = {
    ok: false as const,
    error: 'pos-printing-requires-desktop',
  };
  return {
    async list() {
      return [];
    },
    async register() {
      // No-op — desktop persists this in app preferences.
    },
    async printReceipt() {
      return NOT_SUPPORTED;
    },
    async openCashDrawer() {
      return NOT_SUPPORTED;
    },
    async testPrint() {
      return NOT_SUPPORTED;
    },
  };
}
